const state = {
  loggedInUser: undefined,
}

export default state;